module.exports = __webpack_public_path__ + "img/ti4.2b158dd0.png";